import { render, staticRenderFns } from "./ManterDisciplinaView.vue?vue&type=template&id=ee92ad98"
import script from "./ManterDisciplinaView.vue?vue&type=script&lang=js"
export * from "./ManterDisciplinaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports